export default {
  "cabinet": {
    "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iм'я"])},
    "nickname": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Псевдонім"])},
    "card": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Номер карти"])},
    "lang": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мова"])},
    "ru": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Російська"])},
    "ua": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Українська"])},
    "gender": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Стать"])},
    "male": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Чоловіча"])},
    "female": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жіноча"])},
    "birthday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дата нарождення"])},
    "city": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Місто"])},
    "cityChose": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Оберіть місто"])},
    "cityOptions": {
      "kiev": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Київ"])},
      "lvov": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Львів"])},
      "odessa": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Одеса"])}
    }
  },
  "header": {
    "search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пошук"])},
    "poster": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Афіша"])},
    "schedule": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Розклад"])},
    "cinemas": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кінотеатри"])},
    "sales": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Акції"])},
    "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Про кінотеатр"])},
    "news": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Новини"])},
    "contacts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Контакти"])},
    "cabinet": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мій кабінет"])},
    "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Логін"])},
    "registration": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Регістрація"])}
  },
  "footer": {
    "mobile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мобільні додатки"])},
    "poster": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Афіша"])},
    "schedule": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Розклад"])},
    "cinemas": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кінотеатри"])},
    "sales": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Акції"])},
    "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Про кінотеатр"])},
    "news": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Новини"])}
  },
  "home": {
    "now": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дивіться сьогодні"])},
    "buy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Купити квиток"])},
    "soon": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дивіться скоро"])},
    "news": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Новини та акції"])}
  },
  "film": {
    "buy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Купити квиток"])},
    "schedule": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Розклад сеансів у кінотеатрі:"])},
    "posters": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кадри та постери"])},
    "cinema": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кінотеатр:"])}
  },
  "poster": {
    "now": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Зараз у кіно"])},
    "buy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Купити квиток"])},
    "poster": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Афіша"])}
  },
  "schedule": {
    "cinemas": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Всі кінотеатри"])},
    "films": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Всі фільми"])},
    "halls": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Всі зали"])},
    "list": {
      "time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Час"])},
      "film": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Фільм"])},
      "price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ціна"])},
      "reserve": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Резерв"])}
    },
    "not-found": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сеансів не знайдено"])}
  },
  "order": {
    "price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ціна в грн"])},
    "tickets": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Квитків"])},
    "sum": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сума"])},
    "screen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ЕКРАН"])},
    "order-rules": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вартість бронювання - 3 грн. за кожне місце"])},
    "order-time": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ЗАБРОНЬОВАННІ КВИТКИ ПОТРІБНО ВИКУПИТИ У КАСІ НЕ РАНІШЕ НIЖ ЗА ПІВГОДИНИ ДО ПОЧТАКУ СЕАНСУ"])},
    "order-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ЗАБРОНЮВАТИ"])},
    "buy": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["КУПИТИ"])}
  },
  "cinemas": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Наші кінотеатри"])},
    "conditions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Умови"])},
    "schedule": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Розклад сеансів"])},
    "countHalls": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Кількість залів"])},
    "now": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дивіться сьогодні"])}
  },
  "sales": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Акції та скидки"])}
  },
  "news": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Новини"])}
  },
  "contacts": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Контакти"])}
  }
}